import React from 'react';
import VideoRow from './VideoRow';

const VideoTable = ({
  videos,
  selectedVideos,
  videoForms,
  onSelectVideo,
  onRapperChange,
  onRapperSelect,
  onAddRapper,
  onRemoveRapper,
  onEventChange,
  onAutoImport,
  parsing,
}) => {
  return (
    <div className="bg-battle-gray border border-gray-700 rounded-lg overflow-hidden">
      <div className="overflow-x-auto">
      <table className="w-full min-w-[800px]">
        <thead className="bg-gray-800 border-b border-gray-700">
          <tr>
            <th className="px-4 py-3 text-left text-white font-semibold w-12">
              Select
            </th>
            <th className="px-4 py-3 text-left text-white font-semibold">
              Video
            </th>
            <th className="px-4 py-3 text-left text-white font-semibold">
              Rapper 1
            </th>
            <th className="px-4 py-3 text-left text-white font-semibold">
              Rapper 2
            </th>
            <th className="px-4 py-3 text-left text-white font-semibold">
              More
            </th>
            <th className="px-4 py-3 text-left text-white font-semibold">
              Event Name
            </th>
          </tr>
        </thead>
        <tbody>
          {videos.map((video) => {
            const isSelected = selectedVideos.has(video.youtube_id);
            const form = videoForms[video.youtube_id];

            return (
              <VideoRow
                key={video.youtube_id}
                video={video}
                isSelected={isSelected}
                form={form}
                onSelectVideo={onSelectVideo}
                onRapperChange={onRapperChange}
                onRapperSelect={onRapperSelect}
                onAddRapper={onAddRapper}
                onRemoveRapper={onRemoveRapper}
                onEventChange={onEventChange}
                onAutoImport={onAutoImport}
                parsing={parsing}
              />
            );
          })}
        </tbody>
      </table>
      </div>
    </div>
  );
};

export default VideoTable;
